// extracted by mini-css-extract-plugin
export default {"root":"BodyCell_root__VH-2c","grouping":"BodyCell_grouping__Ye11x"};